import React, { useState, useEffect } from 'react';
import { styled, thoundsandDelimiter } from '@teko/ui';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
`;
const StyledInput = styled.input`
  width: 100%;
  height: 2.1rem;
  line-height: 2.1rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
  z-index: 1;
  &:focus {
    outline: 0;
  }
`;
const PriceInput = (_a) => {
  var _b = _a, {
    value,
    placeholder,
    onChange,
    onEnter
  } = _b, props = __objRest(_b, [
    "value",
    "placeholder",
    "onChange",
    "onEnter"
  ]);
  const getValue = (value2) => {
    const v = parseInt(value2.replace(/[^0-9]/g, ""));
    const numberWithSeparator = isNaN(v) ? "" : thoundsandDelimiter(v);
    return {
      displayValue: numberWithSeparator,
      value: isNaN(v) ? 0 : v
    };
  };
  const [val, setVal] = useState(getValue(value.toString()).displayValue);
  useEffect(() => {
    setVal(getValue(value.toString()).displayValue);
  }, [value]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ React.createElement(StyledInput, {
    type: "text",
    maxLength: 14,
    placeholder,
    value: val,
    onChange: (e) => {
      const { value: value2 } = getValue(e.target.value);
      if (onChange)
        onChange(value2);
    },
    onKeyDown: (e) => {
      if (onEnter && e.keyCode === 13) {
        const { value: value2 } = getValue(val);
        onEnter(value2);
      }
    }
  }));
};

export { PriceInput };
